


import React, { useState } from 'react';
import './sidebar.css';
import { NavLink } from 'react-router-dom';
import { SiMoleculer } from 'react-icons/si';
import { BsFillTriangleFill } from 'react-icons/bs';
import { GiArchiveResearch } from 'react-icons/gi';
import { MdKeyboardArrowDown } from 'react-icons/md';

const Sidebar = () => {
    const [showClinicalSubmenu, setShowClinicalSubmenu] = useState(false);
    const username = localStorage.getItem("username");
    let role = null;
    try {
        const tokenData = JSON.parse(localStorage.getItem("tokendata"));
        role = tokenData?.user?.role || tokenData?.role || null;
    } catch {
        role = null;
    }
    const isAdmin = String(role || "").toLowerCase() === "admin" || username === "admin@gmail.com";

    const getLinkClass = ({ isActive }) =>
        isActive ? "sidebar-link active" : "sidebar-link";

    const handleClinicalMenuToggle = () => {
        setShowClinicalSubmenu((prev) => !prev);
    };

    return (
        <div className="sidebar">
            {isAdmin ? (
                <ul className="sidebar-menu">
                    <li className="sidebar-item">
                        <NavLink to="/adminDashboard" className={getLinkClass}>
                            Admin Dashboard
                        </NavLink>
                    </li>
                    <li className="sidebar-item">
                        <NavLink to="/userManagement" className={getLinkClass}>
                            User Management
                        </NavLink>
                    </li>
                </ul>
            ) : (
                <ul className="sidebar-menu">
                    <li className="sidebar-item">
                        <NavLink to="/myresearch" className={getLinkClass}>
                            <GiArchiveResearch className="sidebar-icon" />
                            My Research
                        </NavLink>
                    </li>
                    <li className="sidebar-item">
                        <button
                            type="button"
                            className="sidebar-link sidebar-toggle-button"
                            onClick={handleClinicalMenuToggle}
                        >
                            <SiMoleculer className="sidebar-icon" />
                            Clinical Research
                            <MdKeyboardArrowDown
                                className={`sidebar-dropdown-icon ${showClinicalSubmenu ? 'open' : ''}`}
                            />
                        </button>
                        {showClinicalSubmenu && (
                            <ul className="sidebar-submenu">
                                <li className="sidebar-item">
                                    <NavLink to="/clinicalresearch" className={getLinkClass}>
                                        Commercial Research
                                    </NavLink>
                                </li>
                                <li className="sidebar-item">
                                    <NavLink to="/r&d" className={getLinkClass}>
                                        {/* <BsFillTriangleFill style={{ marginRight: '8px' }} /> */}
                                        R&D
                                    </NavLink>
                                </li>
                            </ul>
                        )}
                    </li>
                    {/* <li className="sidebar-item">
                        <NavLink
                           
                            className={getLinkClass}>
                            <BsFillTriangleFill style={{ marginRight: '8px' }} />
                          
                            Research Architect Registry
                        </NavLink>
                    </li> */}
                    <li className="sidebar-item">
                        <span
                            className="sidebar-link disabled"
                            title="Clinical Trial Registry is coming soon"
                        >
                            <BsFillTriangleFill className="sidebar-icon" />
                            {/* Clinical Trial Registry */}
                            Research Architect Registry
                        </span>
                    </li>
                </ul>
            )}
        </div>
    );
};

export default Sidebar;
